import * as React from "react";
import "./styles.scss";
import { COLOR } from "../utils/variables";
export var SIZE;
(function (SIZE) {
    SIZE["LARGE"] = "large";
})(SIZE || (SIZE = {}));
export var Button = function (props) {
    var buttonStyle = {
        display: "flex",
        justifyContent: "center",
        fontSize: 14,
        backgroundColor: !props.isDisabled ? props.bgColor ? props.bgColor : COLOR.BUTTON_PRIMARY : COLOR.BUTTON_DISABLED,
        boxShadow: "0px 3px 6px ".concat(COLOR.SHADOW),
        borderRadius: props.rounded ? 22 : 6,
        color: !props.isDisabled ? COLOR.WHITE : COLOR.DARK_GRAY,
        width: !props.width ? props.size === SIZE.LARGE ? "calc(100vw - 30%)" : "calc(100vw - 60%)" : props.width,
        padding: "9px 0",
        maxWidth: props.maxWidth ? props.maxWidth : 300,
        margin: "5px auto",
        height: props.height ? props.height : 47,
        fontWeight: props.fontWeight ? props.fontWeight : 600,
        alignItems: "center",
    };
    return (React.createElement("div", { className: "button ".concat(props.isDisabled ? " disabled" : ""), style: buttonStyle, onClick: function () { return props.onClick ? props.onClick() : undefined; } },
        React.createElement("div", { className: "button-text" }, props.buttonText),
        props.iconUrl &&
            React.createElement("div", { className: "icon" },
                React.createElement("img", { src: props.iconUrl, alt: "icon" }))));
};
export default Button;
//# sourceMappingURL=index.js.map